/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { Rect, Svg } from 'react-native-svg'

export const WindGustSpeedRanges: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 24 24' {...props}>
        <Rect x='4' y='2' fill='#08C6C8' />
        <Rect x='10' y='2' fill='#B59CF5' />
        <Rect x='16' y='2' fill='#E68CC2' />
    </Svg>
)
